import { useState } from "react";
import { Sessione } from "../interfaces/Sessione";
import { TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface ParametriSessionePanelProps {
    sessione: Sessione;
    handleChange: <K extends keyof Sessione>(key: K, value: Sessione[K]) => void;
}


export default function ParametriSessionePanel({ sessione, handleChange }: ParametriSessionePanelProps) {

    return (

        <>
            <h5 className="pb-2">Info generali</h5>
            <div className="mb-3">
                <TextField
                    size="small"
                    label="Nome sessione*"
                    className="form-control"
                    inputProps={{ maxLength: 35 }}
                    value={sessione.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                    helperText={`${sessione.name.length}/35`}
                    FormHelperTextProps={{ style: { textAlign: 'right' } }}
                />
            </div>
            <div className="mb-4">
                <TextField
                    size="small"
                    className="form-control"
                    label="Descrizione*"
                    multiline
                    minRows={2}
                    inputProps={{ maxLength: 300 }}
                    value={sessione.description}
                    onChange={(e) => handleChange("description", e.target.value)}
                    helperText={`${sessione.description.length}/300`}
                    FormHelperTextProps={{ style: { textAlign: 'right' } }}
                />
            </div>
            <div className="d-flex gap-3 mb-3">
                <TextField
                    size="small"
                    label="Tempo attivo* (sec)"
                    type="number"
                    value={sessione.active_time}
                    onChange={(e) => handleChange("active_time", parseInt(e.target.value))}
                    inputProps={{ min: 0 }}
                />
                <TextField
                    size="small"
                    label="Tempo di recupero* (sec)"
                    type="number"
                    value={sessione.recovery_time}
                    onChange={(e) => handleChange("recovery_time", parseInt(e.target.value))}
                    inputProps={{ min: 0 }}
                />
            </div>
            <div className="row">
                <div className="col d-flex">
                    <button
                        className="btn btn-dark"
                        onClick={() => handleChange("repetitions", Math.max(1, sessione.repetitions - 1))}>
                        <RemoveIcon />
                    </button>
                    <input
                        disabled
                        className="form-control mx-3"
                        placeholder="Ripetizioni"
                        value={sessione.repetitions}
                        onChange={(e) => handleChange("repetitions", parseInt(e.target.value))}
                        min="1"
                    />
                    <button
                        className="btn btn-dark"
                        onClick={() => handleChange("repetitions", sessione.repetitions + 1)}>
                        <AddIcon />
                    </button>
                </div>
            </div>
            <div className="row ps-3">
                Indica un numero superiore a 1 solo se vuoi che la sessione venga ripetuta nella sua interezza.
            </div>
        </>
    );
}